import { combineReducers } from 'redux';
import addCustomMetric from './addCustomMetric';
const customMetrics = combineReducers({
    addCustomMetric,
});
  
  
export default customMetrics;